import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { LoginService } from '../../../login/login.service';
import {
  ICamara,
  ICreateSirena,
  IQueryParam,
  ISirena as ISirenaG,
} from 'modelos/src';
import { ISirena } from 'modelosSeguridad/src';
import { firstValueFrom } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { ActivatedRoute } from '@angular/router';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { SirenasHttpService } from '../../../../auxiliares/servicios/http/sirenas.service';
import { PermisosEntidadesService } from '../../../../auxiliares/servicios/http/permisos-entidades.service';

@Component({
  selector: 'app-crear-editar-sirenas',
  templateUrl: './crear-editar-sirenas.component.html',
  styleUrl: './crear-editar-sirenas.component.scss',
  standalone: false,
})
export class CrearEditarSirenasComponent implements OnInit, OnDestroy {
  public clientePropio = LoginService.getCliente();
  public id = signal<string | null>(null);
  public title = signal('');
  public sirena?: ISirenaG;

  public sirenas: ISirena[] = [];
  public camaras: ICamara[] = [];
  //
  public form?: FormGroup;

  //
  private lista2 = inject(Lista2Service);
  private route = inject(ActivatedRoute);
  public helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private sirenasService = inject(SirenasHttpService);
  permisosEntidades = inject(PermisosEntidadesService);

  private async listar() {
    this.sirena = await firstValueFrom(this.lista2.sirenaG(this.id()!));
  }

  private async listarSirenas() {
    const query: IQueryParam = {
      select: 'chipId direccionGps',
    };
    const res = await firstValueFrom(this.lista2.sirenas(query));
    this.sirenas = res?.datos || [];
  }

  private async listarCamaras() {
    // Sin módulo de cámaras el endpoint /camaras responde 403
    if (!this.permisosEntidades.verModuloCamaras()) {
      this.camaras = [];
      return;
    }
    try {
      const query: IQueryParam = {
        select: 'tipo identificacion',
        includeChildren: true,
      };
      const res = await firstValueFrom(this.lista2.camaras(query));
      this.camaras = res?.datos || [];
    } catch (error) {
      console.error('Error al listar cámaras', error);
      this.camaras = [];
    }
  }

  private createForm() {
    // Buscar el chipId de la sirena de integración
    const sirenaIntegracion = this.sirenas.find(
      (s) => s._id === this.sirena?.idExterno,
    );
    const chipId = sirenaIntegracion?.chipId || '';

    this.form = new FormGroup({
      // idExterno?: string; /// El _id que tiene la sirena en seguridad
      // idsAsignados?: string[]; // Camaras, sensores, etc
      chipId: new FormControl({ value: chipId, disabled: true }),
      idExterno: new FormControl(this.sirena?.idExterno),
      idsAsignados: new FormControl(this.sirena?.idsAsignados),
      idModelo: new FormControl(this.sirena?.idModelo),
    });
  }

  private getData(): ICreateSirena {
    return {
      idExterno: this.form?.get('idExterno')?.value,
      idsAsignados: this.form?.get('idsAsignados')?.value,
      idModelo: this.form?.get('idModelo')?.value,
    };
  }

  public async onSubmit() {
    const res = await this.dialogService.confirm(
      'Confirmar',
      '¿Estás seguro de que deseas guardar los cambios?',
    );
    if (!res) {
      return;
    }
    const data = this.getData();
    try {
      if (this.id()) {
        await this.sirenasService.update(this.id()!, data);
        this.helper.notifSuccess('Sirena actualizada');
        this.helper.volver();
      } else {
        await this.sirenasService.create(data);
        this.helper.notifSuccess('Sirena creada');
        this.helper.volver();
      }
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  async ngOnInit() {
    const params = await firstValueFrom(this.route.paramMap);
    const id = params.get('id');
    if (id) {
      this.id.set(id);
    }
    this.title.set(this.id() ? 'Editar Sirena' : 'Crear Sirena');
    await Promise.all([this.listarSirenas(), this.listarCamaras()]);
    if (this.id()) {
      await this.listar();
    }
    this.createForm();
  }

  ngOnDestroy(): void {}
}
